import { supabase } from '@/integrations/supabase/client';
import { setStepVideoOverrides } from './step-videos';

let loaded = false;
let loadingPromise: Promise<void> | null = null;

/**
 * Loads done lovable_video_jobs and registers them as runtime overrides
 * for STEP_VIDEOS so newly generated videos appear app-wide without code edits.
 * Idempotent — call once at app startup.
 */
export async function loadLovableVideoOverrides(): Promise<void> {
  if (loaded) return;
  if (loadingPromise) return loadingPromise;

  loadingPromise = (async () => {
    const { data, error } = await supabase
      .from('lovable_video_jobs')
      .select('step_key, result_url, updated_at')
      .eq('status', 'done')
      .not('result_url', 'is', null)
      .order('updated_at', { ascending: true }); // newest wins via overwrite

    if (error) {
      console.warn('[lovable-video-overrides] load failed', error);
      return;
    }

    const map: Record<string, string> = {};
    for (const row of data ?? []) {
      if (row.step_key && row.result_url) map[row.step_key] = row.result_url;
    }
    setStepVideoOverrides(map);
    loaded = true;
  })();

  return loadingPromise;
}
